import { render, staticRenderFns } from "./NewStowageAdd.vue?vue&type=template&id=a39cfd54&scoped=true&"
import script from "./NewStowageAdd.vue?vue&type=script&lang=js&"
export * from "./NewStowageAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewStowageAdd.vue?vue&type=style&index=0&id=a39cfd54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39cfd54",
  null
  
)

export default component.exports